module.exports = __webpack_public_path__ + "img/img8.0ebf8b57.png";